const uploadFileToS3 = async (file) => {
  const response = await fetch("/api/upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file: {
        name: file.name,
        type: file.type,
        size: file.size,
      },
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || errorData.error || "Failed to upload file"
    );
  }

  const { uploadUrl, fileName } = await response.json();

  const uploadResponse = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!uploadResponse.ok) {
    const errorText = await uploadResponse.text();
    const codeMatch = errorText.match(/<Code>([^<]+)<\/Code>/);
    const messageMatch = errorText.match(/<Message>([^<]+)<\/Message>/);
    const s3Code = codeMatch?.[1];
    const s3Message = messageMatch?.[1];

    throw new Error(
      s3Message
        ? `Failed to upload file to S3 (${uploadResponse.status}: ${s3Code} - ${s3Message})`
        : `Failed to upload file to S3 (${uploadResponse.status})`
    );
  }

  return fileName;
};

const viewFileFromS3 = async (fileName) => {
  const response = await fetch(`/api/resumeUrl?fileName=${fileName}`);

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to get file URL");
  }

  const { viewUrl } = await response.json();

  return viewUrl;
};

export { uploadFileToS3, viewFileFromS3 };
